import styled, { css } from 'foundations-theming/utils';
import { TableRow } from 'foundations-components/transitional/components/Table';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Flex } from 'foundations-components/components/Flex';
import { StyledTableCell } from '../table/StyledTableCell';
import { useMilestoneTableSize } from '../table/MilestoneTableSizeContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonBlock = styled.div.withConfig({
  displayName: "MilestoneSkeletonRow__SkeletonBlock"
})(["", ""], ({
  theme,
  width
}) => css(["height:14px;width:", ";border-radius:", ";background-color:", ";"], width !== null && width !== void 0 ? width : '70%', theme.borderRadius['full'], theme.color['border-core-default']));
export function MilestoneSkeletonRow() {
  const size = useMilestoneTableSize();
  if (size === 'small') {
    return /*#__PURE__*/_jsxs(TableRow, {
      children: [/*#__PURE__*/_jsx(StyledTableCell, {
        children: /*#__PURE__*/_jsx(Checkbox, {
          checked: false,
          disabled: true,
          size: "sm",
          marginBlockStart: "100"
        })
      }), /*#__PURE__*/_jsx(StyledTableCell, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "200",
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {}), /*#__PURE__*/_jsx(SkeletonBlock, {
            width: "55%"
          })]
        })
      }), /*#__PURE__*/_jsx(StyledTableCell, {
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          width: "32px"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(TableRow, {
    children: [/*#__PURE__*/_jsx(StyledTableCell, {
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: false,
        disabled: true,
        size: "sm",
        marginBlockStart: "100"
      })
    }), /*#__PURE__*/_jsx(StyledTableCell, {
      children: /*#__PURE__*/_jsx(SkeletonBlock, {
        width: "65%"
      })
    }), /*#__PURE__*/_jsx(StyledTableCell, {
      children: /*#__PURE__*/_jsx(SkeletonBlock, {
        width: "55%"
      })
    }), /*#__PURE__*/_jsx(StyledTableCell, {
      children: /*#__PURE__*/_jsx(SkeletonBlock, {
        width: "50%"
      })
    })]
  });
}